<template>
  <div class="auth-shell">
    <div class="auth-card">
      <div class="auth-lockup">
        <router-link to="/" class="auth-wordmark">MLS Ingest</router-link>
        <div class="auth-parent-line">
          a <span class="auth-parent-mark">Brokurz</span> company
        </div>
      </div>

      <Message v-if="error" severity="error" :closable="false" class="tw-mb-3">{{ error }}</Message>

      <form @submit.prevent="submit">
        <div class="field">
          <label class="field-label">Email</label>
          <InputText v-model="email" type="email" autocomplete="username" class="tw-w-full" required />
        </div>
        <div class="field">
          <label class="field-label">Password</label>
          <Password v-model="password" :feedback="false" toggleMask inputClass="tw-w-full" class="tw-w-full" required />
        </div>
        <Button
          type="submit"
          label="Sign in"
          icon="pi pi-sign-in"
          class="tw-w-full"
          :loading="loading"
        />
      </form>

      <p class="auth-help">
        Invited? Open the link in your email to set a password, then sign in here.
      </p>
      <p class="auth-parent">mlsingest.com · MLS Ingest is a Brokurz company</p>
    </div>
  </div>
</template>

<script>
import { authState } from '../lib/auth'

export default {
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      error: null,
    }
  },
  methods: {
    async submit() {
      this.loading = true
      this.error = null
      try {
        await authState.signIn(this.email.trim(), this.password)
        const redirect = this.$route.query.redirect || '/dashboard'
        this.$router.replace(redirect)
      } catch (err) {
        this.error = err.message || 'Sign in failed'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.auth-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: #f4f4f5;
}

.auth-card {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 1.75rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.auth-lockup {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.22rem;
  margin-bottom: 1.35rem;
}

.auth-wordmark {
  font-size: 1.45rem;
  font-weight: 700;
  letter-spacing: -0.06em;
  color: #18181b;
  line-height: 1;
  text-decoration: none;
}

.auth-parent-line {
  display: inline-flex;
  align-items: baseline;
  gap: 0.28em;
  font-size: 0.68rem;
  font-weight: 400;
  letter-spacing: 0.01em;
  color: #18181b;
  line-height: 1;
}

.auth-parent-mark {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: -0.055em;
  color: #18181b;
}

.auth-help {
  margin-top: 1rem;
  font-size: 0.8rem;
  color: #71717a;
}

.auth-parent {
  margin: 1.25rem 0 0;
  padding-top: 1rem;
  border-top: 1px solid #e4e4e7;
  font-size: 0.72rem;
  color: #a1a1aa;
  letter-spacing: 0.01em;
}
</style>
